import React from 'react'
import styles from './SNS.module.scss'

const SNSImage = () => {
  return <div className={styles['sns-image']}></div>
}

const SNS = () => (
  <section className={styles['sns']}>
    <article className={styles['content']}>
      <h1>Planissue SNS</h1>
      <section className={styles['discription']}>
        플랜이슈의 이슈메이커들은 언제 어디서나 함께합니다.
      </section>
      <section className={styles['discription']}>
        일할 때 재미있게, 놀 때 더 재미있게!
      </section>
      <section className={styles['discription']}>
        매일매일 즐거운 일이 가득한 플랜이슈의 일상을 엿보세요.
      </section>
    </article>
    <section className={styles['sns-images']}>
      <SNSImage />
      <SNSImage />
      <SNSImage />
      <SNSImage />
      <SNSImage />
      <SNSImage />
      <SNSImage />
      <SNSImage />
      <SNSImage />
      <SNSImage />
    </section>
  </section>
)

export default SNS
